import { render, staticRenderFns } from "./addAgreements.vue?vue&type=template&id=e2cad1e0&"
import script from "./addAgreements.vue?vue&type=script&lang=js&"
export * from "./addAgreements.vue?vue&type=script&lang=js&"
import style0 from "./addAgreements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports